"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var colors_1 = require("../../../style/colors");
var layout_1 = require("../../layout");
var Text_1 = __importDefault(require("../../Text"));
var style_1 = require("../../../style");
var ChipClose_1 = __importDefault(require("./ChipClose"));
var ChipBadge_1 = __importDefault(require("./ChipBadge"));
var ChipAvatar_1 = __importDefault(require("./ChipAvatar"));
var createChipStyle = function (disabled) { return ({
    base: react_1.css({
        height: 28,
        padding: '0 10px',
        border: "1px solid " + style_1.DesignSystemThemeColor.Gray.LIGHT_2,
        color: style_1.DesignSystemThemeColor.Gray.DARK_2,
        background: '#fff',
        borderRadius: 6,
        width: '100%',
    }),
    selectable: react_1.css({
        cursor: 'pointer',
        ':hover': {
            background: style_1.DesignSystemThemeColor.Gray.LIGHT_6,
            borderColor: style_1.DesignSystemThemeColor.Gray.LIGHT_1,
        },
    }),
    disabled: react_1.css({
        background: style_1.DesignSystemThemeColor.Gray.LIGHT_5,
        borderColor: style_1.DesignSystemThemeColor.Gray.LIGHT_3,
        color: style_1.DesignSystemThemeColor.Gray.LIGHT_2,
        cursor: 'not-allowed',
    }),
    selected: react_1.css({
        cursor: 'pointer',
        background: style_1.DesignSystemThemeColor.Primary.LIGHT_6,
        borderColor: style_1.DesignSystemThemeColor.Primary.LIGHT_1,
        color: style_1.DesignSystemThemeColor.Primary.DEFAULT,
    }),
    closebtn: react_1.css({
        marginRight: -3,
        color: disabled ? colors_1.SixsenseColor.Gray.LIGHT_1 : colors_1.SixsenseColor.Gray.DEFAULT,
        cursor: 'pointer',
        verticalAlign: 'middle',
    }),
    title: react_1.css({
        color: '#5B6C75',
        fontWeight: 400,
        fontSize: 14,
    }),
    labelContainer: react_1.css({
        zIndex: 2,
        flex: 1,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    }),
}); };
var Chip = function (_a) {
    var children = _a.children, selected = _a.selected, disabled = _a.disabled, onSelect = _a.onSelect, onDismiss = _a.onDismiss, badgeContent = _a.badgeContent, avatarProps = _a.avatarProps, props = __rest(_a, ["children", "selected", "disabled", "onSelect", "onDismiss", "badgeContent", "avatarProps"]);
    var defaultStyle = react_2.useMemo(function () { return createChipStyle(disabled); }, [disabled]);
    return (react_1.jsx(Text_1.default.Body, __assign({ weight: "semibold" }, props),
        react_1.jsx(layout_1.Flex, { onClick: disabled ? undefined : onSelect, inline: true, alignItems: "center", gap: 6, css: [
                defaultStyle.base,
                onSelect && !selected && !disabled ? defaultStyle.selectable : undefined,
                selected ? defaultStyle.selected : undefined,
                disabled ? defaultStyle.disabled : undefined,
            ] },
            avatarProps ? react_1.jsx(ChipAvatar_1.default, __assign({}, avatarProps, { disabled: disabled })) : null,
            react_1.jsx("span", { css: defaultStyle.labelContainer }, children),
            badgeContent ? react_1.jsx(ChipBadge_1.default, null, badgeContent) : null,
            onDismiss ? react_1.jsx(ChipClose_1.default, { disabled: disabled, onClick: onDismiss }) : null)));
};
exports.default = Chip;
